<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">{{ component.name }}</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <div class="d-flex">
        <router-link :to="{ name: 'client-component-knowledgecheck', params: { knowledgecheckId: component.knowledgecheck_id } }">
          <i class="fas fa-exchange-alt"></i> Switch to User View
        </router-link>
        <div class="flex-grow-1"></div>
        <select-questions :id="component.knowledgecheck_id"></select-questions>
      </div>
    </span>
    <b-tabs v-model="currentTab" card no-fade>
      <b-tab title="All" active>
        <all
          ref="all"
          v-model="model.questions"
          @edit-question="onQuestionEditing"
          @delete-question="onQuestionDelete"
        />
      </b-tab>
      <b-tab title="Archived" lazy>
        <archived
          ref="archived"
          v-model="archivedQuestions"
          @restore-question="onQuestionRestore"
        />
      </b-tab>
      <b-tab title="<i class='fas fa-plus'></i> Add">
        <add-question
          ref="add"
          v-model="model"
          @added="onQuestionAdd"
          @cancel="onQuestionCancel"
        />
      </b-tab>
      <b-tab title="<i class='fas fa-cog' title='knowledge check properties details'></i> Properties">
        <edit ref="edit" v-model="model"/>
      </b-tab>
      <b-tab v-if="editingQuestion" lazy title="<i class='fas fa-edit' title='edit question'></i> Edit Question">
        <edit-question
          ref="add"
          v-model="model"
          :question="editingQuestion"
          @edited="onQuestionEdited"
          @cancel="onQuestionEditCancel"
        />
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import _ from 'lodash'
import api from '@/api/knowledgechecks/knowledgecheck.js'
import questionApi from '@/api/knowledgechecks/questions.js'
import { mapState } from 'vuex'

import addQuestion from './add-question'
import all from './all'
import archived from './archived'
import edit from './edit'
import editQuestion from './edit-question'

import sidebar from '@/components/sidebar'
import page from '@/components/templates/page'
import selectQuestions from '../print/select-questions'

export default {
  components: {
    addQuestion,
    all,
    archived,
    edit,
    editQuestion,
    sidebar,
    page,
    selectQuestions
  },
  data () {
    return {
      archivedQuestions: [],
      currentTab: 0,
      previousTab: 0,
      editingQuestion: null,
      isLoaded: false,
      model: {},
      breadcrumbs: [
        {
          text: 'Modules',
          to: { name: 'admin-modules' }
        },
        {
          text: 'Components',
          to: {
            name: 'admin-components'
          }
        },
        {
          text: 'Knowledge Check',
          active: true
        }
      ]
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('components', {
      component: 'current'
    }),
    ...mapState('knowledgechecks', {
      fetching: state => state.views.component.fetching
    })
  },
  watch:{
    currentTab(val){
      if(val != 4){
        this.editingQuestion = null
      }
    }
  },
  async mounted(){
    if(!this.component.knowledgecheck_id){
      this.$router.push({name: 'admin-component-knowledgecheck-create', params: {component: this.component.id}})
    }
    else{
      await this.loadKnowledgeCheck()
    }
  },
  methods: {
    setFetching(value){
      this.$store.dispatch('knowledgechecks/setFetching', {view: 'component', value})
    },
    async loadKnowledgeCheck(){
      this.setFetching(true)

      const params = {
        tenantId: this.organization.id,
        knowledgecheckId: this.component.knowledgecheck_id
      }

      const response = await api.show(params)
      this.model = response.data.data

      await this.loadArchivedQuestions()

      this.isLoaded = true
      this.setFetching(false)
    },
    async loadArchivedQuestions(){
      const params = {
        tenantId: this.organization.id,
        knowledgecheckId: this.component.knowledgecheck_id
      }

      const response = await questionApi.archived(params)
      this.archivedQuestions = response.data.data
    },
    printPreview(){
      alert('select number')
    },
    onQuestionAdd(q){
      this.model.questions.push(q)
      this.currentTab = 0
    },
    onQuestionCancel(){
      this.currentTab = 0
    },
    onQuestionEditing(q){
      this.editingQuestion = q

      this.$nextTick(() => {
        this.previousTab = this.currentTab
        this.currentTab = 4
      })
    },
    onQuestionEdited(q){
      this.editingQuestion = Object.assign(this.editingQuestion, q)
      this.editingQuestion = null
      this.currentTab = this.previousTab
      this.previousTab = 0
    },
    onQuestionEditCancel(){
      this.editingQuestion = null
      this.currentTab = this.previousTab
      this.previousTab = 0
    },
    async onQuestionDelete(q){
      this.setFetching(true)

      const payload = {
        tenantId: this.organization.id,
        knowledgecheckId: this.component.knowledgecheck_id,
        questionId: q.id
      }

      await questionApi.destroy(payload)

      const existing = _.find(this.model.questions, function(o){ return o.id == q.id })
      this.model.questions.splice(this.model.questions.indexOf(existing), 1)

      this.loadArchivedQuestions()

      this.setFetching(false)
    },
    async onQuestionRestore(q){
      this.setFetching(true)

      const payload = {
        tenantId: this.organization.id,
        knowledgecheckId: this.component.knowledgecheck_id,
        questionId: q.id
      }

      const response = await questionApi.restore(payload)
      this.model.questions.push(response.data.data)

      await this.loadArchivedQuestions()

      this.setFetching(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/index.vue